// The /ssr entry renders without React context, so the same component works in server and client trees.
import { CheckCircle, Info, Warning, XCircle } from "@phosphor-icons/react/ssr";
import clsx from "clsx";

export type StatusKind = "success" | "warning" | "error" | "info";

const icons = { success: CheckCircle, warning: Warning, error: XCircle, info: Info } as const;
const colors = {
  success: "text-status-success",
  warning: "text-status-warning",
  error: "text-status-error",
  info: "text-status-info",
} as const;

/**
 * A status is a structure, never a swatch: the matching approved icon, a
 * visible label naming the state, native semantics, and the status colour on
 * icon and label only (10_component-anatomy.md §5).
 */
export function Status({ kind, label, id, className }: { kind: StatusKind; label: string; id?: string; className?: string }) {
  const Icon = icons[kind];
  return (
    <span id={id} role={kind === "error" ? "alert" : "status"} className={clsx("inline-flex items-center gap-2 text-small font-medium", colors[kind], className)}>
      <Icon size={16} weight="regular" aria-hidden="true" />
      <span>{label}</span>
    </span>
  );
}
